import client from "./clients/portalClient";

const getAllServiceProjects = () => client.get(`/service_projects`);
const getServiceProject = (id) => client.get(`/service_projects/${id}`);
const editServiceProject = (id, data) => client.put(`/service_projects/${id}`, data);

const getServiceProjectHistory = (id) => client.get(`/service_projects/${id}/history`);


const getServiceProjectIp = (id) => client.get(`/service_projects/${id}/ip`);
const postServiceProjectIp = (id, data) => client.post(`/service_projects/${id}/ip`, data);
const editServiceProjectIp = (id, ipId, data) => client.put(`/service_projects/${id}/ip/${ipId}`, data);
const deleteServiceProjectIp = (id, ipId) => client.delete(`/service_projects/${id}/ip/${ipId}`);

const getServiceProjectController = (id) => client.get(`/service_projects/${id}/controller`);
const postServiceProjectController = (id, data) => client.post(`/service_projects/${id}/controller`, data);
const editServiceProjectController = (id, ipId, data) => client.put(`/service_projects/${id}/controller/${ipId}`, data);
const deleteServiceProjectController = (id, ipId) => client.delete(`/service_projects/${id}/controller/${ipId}`);

const getServiceProjectLogin = (id) => client.get(`/service_projects/${id}/login`);
const postServiceProjectLogin = (id, data) => client.post(`/service_projects/${id}/login`, data);
const editServiceProjectLogin = (id, ipId, data) => client.put(`/service_projects/${id}/login/${ipId}`, data);
const deleteServiceProjectLogin = (id, ipId) => client.delete(`/service_projects/${id}/login/${ipId}`);

const getAllTickets = () => client.get(`/service_tickets`);
const getServiceProjectTicket = (id, tId) => client.get(`/service_projects/${id}/tickets/${tId}`);
const getServiceProjectTickets = (id) => client.get(`/service_projects/${id}/tickets`);
const postServiceProjectTickets = (id, data) => client.post(`/service_projects/${id}/tickets`, data);
const editServiceProjectTickets = (id, rId, data) => client.put(`/service_projects/${id}/tickets/${rId}`, data);
const deleteServiceProjectTickets = (id, rId) => client.delete(`/service_projects/${id}/tickets/${rId}`);

const getTicketDetailsHistory = (tId) => client.get(`/service_tickets/${tId}/history`);
const getTicketDetailsMessages = (id, tId) => client.get(`/service_projects/${id}/tickets/${tId}/comments`);
const postTicketDetailsMessages = (id, tId, data) => client.post(`/service_projects/${id}/tickets/${tId}/comments`, data);
const deleteTicketDetailsMessages = (id, sId, tId) => client.delete(`/service_projects/${id}/tickets/${sId}/comments/${tId}`);

const getBMS = () => client.get(`/software_bms`);
const getDDC = () => client.get(`/software_ddc`);

const getTemplates = (id, cat) => client.get(`/service_projects/${id}/template?template=${cat}`)

const getServiceMessages = (id) => client.get(`/service_projects/${id}/comments`)
const postServiceMessages = (id, data) => client.post(`/service_projects/${id}/comments`, data);
const deleteServiceMessages = (id, mId) => client.delete(`/service_projects/${id}/comments/${mId}`);


const serviceProjectApi = {
    getAllServiceProjects,
    getServiceProject,
    editServiceProject,
    getServiceProjectHistory,


    getServiceProjectIp,
    postServiceProjectIp,
    editServiceProjectIp,
    deleteServiceProjectIp,

    getServiceProjectController,
    postServiceProjectController,
    editServiceProjectController,
    deleteServiceProjectController,

    getServiceProjectLogin,
    postServiceProjectLogin,
    editServiceProjectLogin,
    deleteServiceProjectLogin,

    getAllTickets,
    getServiceProjectTicket,
    getServiceProjectTickets,
    postServiceProjectTickets,
    editServiceProjectTickets,
    deleteServiceProjectTickets,

    getTicketDetailsHistory,
    getTicketDetailsMessages,
    postTicketDetailsMessages,
    deleteTicketDetailsMessages,

    getBMS,
    getDDC,
    getTemplates,

    getServiceMessages,
    postServiceMessages,
    deleteServiceMessages
};

export default serviceProjectApi;